var ready = function(fn) {
  if (typeof fn !== 'function') { 
    return; 
  }
  if (document.readyState === 'complete') {
    return fn();
  }
  document.addEventListener('DOMContentLoaded', fn, false);
};


ready(function() {
  var is_slider_page = document.querySelector('.glide');
  if (is_slider_page.length !== 0) {
    new Glide('.glide', {
      type: 'carousel',
      autoplay: 5000,
    }).mount();
  }
});

ready(function() {
  var is_gallery = document.querySelector('.Gallery');
  if ( is_gallery.length !== 0 ) { 
    baguetteBox.run('.Gallery');
  }
});






